<div class="container-fluid regular-tab-content">
  <div class="green-table">
    <div
      class="table-action-wrapper d-flex align-items-center justify-content-between"
    >
      <div class="d-flex">
        <div id="reports_dqr_customers_search" class="search-input">
          <img
            src="../../assets/icons/search.svg"
            alt="Search icon"
            (click)="search()"
          />
          <input
            class="smaller-font"
            type="text"
            [placeholder]="'COMMON.SEARCH' | translate"
            [(ngModel)]="searchText"
            (keydown.enter)="search()"
            (ngModelChange)="this.searchTextUpdate.next($event)"
          />
        </div>
        <div id="reports_dqr_customers_search-by" class="search-type-picker">
          <div
            class="dropdown smaller-font"
            (click)="showSelectSearchType = !showSelectSearchType"
            click-stop-propagation
          >
            <span class="label smaller-font"
              >{{ "COMMON.BY" | translate }}:</span
            >
            <span style="width: 60%;">{{ selectedSearchTypeDisplay | translate }}</span>
            <i class="arrow-custom --small down"></i>
          </div>
          <div class="dropdown-opened" style="width: 130%;" *ngIf="showSelectSearchType">
            <div
              [id]="'reports_dqr_customers_search-by-' + (i + 1)" (click)="selectSearchType(searchType)"
              *ngFor="let searchType of searchByOptions; let i = index"
            >
              <div>{{ searchType.translation | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-auto d-flex">
        <div>
          <div class="d-flex">
            <div id="reports_dqr_customers_date-type" class="datetype-picker">
              <div
                class="dropdown smaller-font"
                (click)="showSelectDateType = !showSelectDateType"
                click-stop-propagation
              >
                <span class="smaller-font"
                  >{{ "COMMON.DATE_TYPE.TITLE" | translate }}:</span
                >
                <span style="width: 50%">{{ selectedDateTypeDisplay | translate }}</span>
                <i class="arrow-custom --small down"></i>
              </div>
              <div class="dropdown-opened" *ngIf="showSelectDateType">
                <div
                  [id]="'reports_dqr_customers_date-type-' + (i + 1)" (click)="
                    selectDateType(dateType);
                    datesValid() == true && (dateTo || dateFrom) && search()
                  "
                  *ngFor="let dateType of dateTypes; let i = index"
                >
                  <div>{{ dateType.translation | translate }}</div>
                </div>
              </div>
            </div>
            <div id="reports_dqr_customers_date-from" class="datepicker-box space-right smaller-font">
              <label class="smaller-font" for="dateFrom">
                {{ "COMMON.FROM" | translate }}:
              </label>
              <input
                #fromPicker
                onclick="this.showPicker()"
                placeholder="dd/mm/yyyy"
                type="date"
                id="dateFrom"
                name="dateFrom"
                [ngClass]="
                  !datesValid() ? 'datepicker-input-error' : 'datepicker-input'
                "
                [(ngModel)]="dateFrom"
                (change)="datesValid() == true && search()"
              />
              <i class="arrow-custom --small down"></i>
            </div>

            <div id="reports_dqr_customers_date-to" class="datepicker-box space-right smaller-font">
              <label class="smaller-font" for="dateTo">
                {{ "COMMON.TO" | translate }}:
              </label>
              <input
                onclick="this.showPicker()"
                type="date"
                id="dateTo"
                name="dateTo"
                [ngClass]="
                  !datesValid() ? 'datepicker-input-error' : 'datepicker-input'
                "
                [(ngModel)]="dateTo"
                (change)="datesValid() == true && search()"
              />
              <i class="arrow-custom --small down"></i>
            </div>
          </div>
        </div>
        <div
          id="reports_dqr_customers_sort-by"
          class="sort-by-root"
          (click)="showSortBy = !showSortBy"
          click-stop-propagation
        >
          <div class="dropdown smaller-font">
            <span class="smaller-font"
              >{{ "COMMON.SORT_BY.TITLE" | translate }}:</span
            >
            <span style="width: 40%;">{{ sortByLabelValue.translation | translate }}</span>
            <i class="arrow-custom --small down"></i>
          </div>
          <div class="dropdown-opened" style="width: 115%;" *ngIf="showSortBy">
            <div id="reports_dqr_customers_sort-by-newest" (click)="sortBy(sortByOptions.NEWEST)">
              <div>{{ "COMMON.SORT_BY.NEWEST" | translate }}</div>
            </div>
            <div id="reports_dqr_customers_sort-by-slrn-asc" (click)="sortBy(sortByOptions.SLRN_ASC)">
              <div>{{ "COMMON.SLRN" | translate }}</div>
              <img
                class="arrow-up"
                src="../../../assets/icons/arrow.svg"
                alt="Arrow icon"
              />
            </div>
            <div id="reports_dqr_customers_sort-by-slrn-desc" (click)="sortBy(sortByOptions.SLRN_DESC)">
              <div>{{ "COMMON.SLRN" | translate }}</div>
              <img src="../../../assets/icons/arrow.svg" alt="Arrow icon" />
            </div>
            <div id="reports_dqr_customers_sort-by-acc-no-asc" (click)="sortBy(sortByOptions.ACCNO_ASC)">
              <div>{{ "COMMON.SORT_BY.ACCOUNT_NO" | translate }}</div>
              <img
                class="arrow-up"
                src="../../../assets/icons/arrow.svg"
                alt="Arrow icon"
              />
            </div>
            <div id="reports_dqr_customers_sort-by-acc-no-desc" (click)="sortBy(sortByOptions.ACCNO_DESC)">
              <div>{{ "COMMON.SORT_BY.ACCOUNT_NO" | translate }}</div>
              <img src="../../../assets/icons/arrow.svg" alt="Arrow icon" />
            </div>
          </div>
        </div>
        <button class="button primary--white four-radius" (click)="download()">
          <span class="smaller-font">{{ "COMMON.DOWNLOAD" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="filter">
      <div class="filter-list">
        <span class="label smaller-font">
          {{ "COMMON.FILTER" | translate }}</span
        >
        <ng-container *ngIf="hasCimDataIntegration; else legacyRegionFilters">
          <app-multi-select-dropdown id="reports_dqr_customers_geographical_region_filter" class="multiselect"
            [clicked]="clicked" [items]="geographicalRegions" [label]="'COMMON.BU.PLURAL'" [borderRadius]="'0.4rem'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectGeographicalRegion($event)">
          </app-multi-select-dropdown>
          <app-multi-select-dropdown id="reports_dqr_customers_sub_geographical_region_filter" class="multiselect smaller-font"
            [clicked]="clicked" [items]="subGeographicalRegions" [label]="'COMMON.UT.PLURAL'" [borderRadius]="'0.4rem'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectSubGeographicalRegion($event)">
          </app-multi-select-dropdown>
        </ng-container>
        <ng-template #legacyRegionFilters>
          <app-multi-select-dropdown id="reports_dqr_customers_region_filter" class="multiselect" [clicked]="clicked"
            [items]="regions" [label]="'COMMON.BU.PLURAL'" [borderRadius]="'0.4rem'" [showMore]="false" [requireApply]="true"
            (shareIndividualCheckedList)="selectRegion($event)">
          </app-multi-select-dropdown>
          <app-multi-select-dropdown id="reports_dqr_customers_area_filter" class="multiselect smaller-font" [clicked]="clicked"
            [items]="areas" [label]="'COMMON.UT.PLURAL'" [borderRadius]="'0.4rem'" [showMore]="false" [requireApply]="true"
            (shareIndividualCheckedList)="selectArea($event)">
          </app-multi-select-dropdown>
        </ng-template>
        <select
          id="reports_dqr_customers_tariff_filter"
          name="tariff-select"
          (change)="selectTariff($event)"
          class="form-select"
        >
          <option value="0" [selected]="tariff == 0" disabled>
            {{ "COMMON.TARIFF.SINGLE" | translate }}
          </option>
          <option
            [id]="'reports_dqr_customers_tariff_filter-' + (i + 1)"
            [selected]="tariff == o.id"
            *ngFor="let o of tariffs; let i = index"
            value="{{ o.id }}"
          >
            {{ o.name }}
          </option>
        </select>

        <select
          id="reports_dqr_customers_user-type_filter"
          *ngIf="isServiceTypeFieldVisible"
          name="st-select"
          (change)="selectUserType($event)"
          class="form-select"
        >
          <option value="" [selected]="!userType" disabled>
            {{ "COMMON.USER.TYPE.TITLE" | translate }}
          </option>
          <option
            [id]="'reports_dqr_customers_user-type_filter-' + (i + 1)"
            [selected]="userType == o.value"
            *ngFor="let o of userTypeOptions; let i = index"
            value="{{ o.value }}"
          >
            {{ o.translation | translate }}
          </option>
        </select>

        <app-multi-select-dropdown
          id="reports_dqr_customers_user_filter"
          class="multiselect"
          [searchFilterActive]="true"
          [borderRadius]="'0.4rem'"
          (filterValue)="applySearchFilter($event)"
          [clicked]="clicked"
          [items]="filteredUsers"
          [label]="'COMMON.USER.PLURAL'"
          [showMore]="false"
          [requireApply]="true"
          (shareIndividualCheckedList)="selectUsers($event)"
        >
        </app-multi-select-dropdown>
        <select
          id="reports_dqr_customers_tag_filter"
          name="tag-select"
          (change)="selectTag($event)"
          class="form-select"
        >
          <option value="" [selected]="!tag" disabled>
            {{ "COMMON.TAG.TITLE" | translate }}
          </option>
          <option
            [id]="'reports_dqr_customers_tag_filter-' + (i + 1)"
            [selected]="tag == t.value"
            *ngFor="let t of tagOptions; let i = index"
            value="{{ t.value }}"
          >
            {{ t.translation | translate }}
          </option>
        </select>
        <select
          id="reports_dqr_customers_slt-status_filter"
          name="slt-select"
          (change)="selectSltStatus($event)"
          class="form-select"
        >
          <option value="" [selected]="!sltStatus" disabled>
            {{ 'COMMON.SLT_STATUS.SINGLE' | translate }}
          </option>
          <option
            [id]="'reports_dqr_customers_slt-status_filter-' + (i + 1)"
            [selected]="sltStatus == s.key"
            *ngFor="let s of sltOptions; let i = index"
            value="{{ s.key }}"
          >
            {{ s.value }}
          </option>
        </select>

        <select
          id="reports_dqr_customers_uop_filter"
          name="uop-select"
          (change)="selectUseOfPremises($event)"
          class="form-select"
        >
          <option value="" [selected]="!useOfPremises" disabled>
            {{ "COMMON.USE_OF_PREMISES" | translate }}
          </option>
          <option
            [id]="'reports_dqr_customers_uop_filter-' + (i + 1)"
            [selected]="useOfPremises == u.value"
            *ngFor="let u of uopOptions; let i = index"
            value="{{ u.value }}"
          >
            {{ u.translation | translate }}
          </option>
        </select>
      </div>
      <div *ngIf="selectedFilters.length > 0">
        <app-filter-checklist [filters]="selectedFilters" (resetFilterEmitter)="resetFilter($event)"
          (removeFilterEmitter)="removeFilter($event)" [useApply]="true" (applyFilterEmitter)="applyFilter($event)">
        </app-filter-checklist>
      </div>
    </div>
    <div class="table">
      <div *ngIf="customers">
        <table class="table">
          <thead class="table-light">
            <tr>
              <th id="reports_dqr_customers_table_header_row-checkbox" class="checkbox">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [ngModel]="allCheckboxesChecked"
                  (click)="checkAllCheckboxes()"
                />
              </th>
              <th id="reports_dqr_customers_table_header_row-slrn">{{ "COMMON.SLRN" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-building-owner">{{ "COMMON.TABLE_HEADERS.BUILDING_OWNER" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-acc-no">{{ "COMMON.TABLE_HEADERS.ACCT_NO" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-meter-no">{{ "COMMON.TABLE_HEADERS.METER_NO" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-dt">{{ "COMMON.DT_NAME" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-address">{{ "COMMON.ADDRESS" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-region">
                {{ "COMMON.BU.SINGLE" | translate }}
              </th>
              <th id="reports_dqr_customers_table_header_row-district">
                {{ "COMMON.UT.SINGLE" | translate }}
              </th>
              <th id="reports_dqr_customers_table_header_row-tariff">{{ "COMMON.TARIFF.SINGLE" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-validation-status">{{ "COMMON.VALIDATION_STATUS" | translate }}</th>
              <th id="reports_dqr_customers_table_header_row-tag">{{ "COMMON.TAG.TITLE" | translate }}</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              [id]="'reports_dqr_customers_table_row-' + (i + 1)" *ngFor="let customer of customers; let i = index"
              (click)="selectDataQuality(customer.id, customer.isOnBoard)"
            >
              <td [id]="'reports_dqr_customers_table_checkbox' + (i + 1)">
                <input
                  type="checkbox"
                  (click)="checkCustomer(customer.id)"
                  class="form-check-input"
                  [ngModel]="customer.isChecked"
                />
              </td>
              <td [id]="'reports_dqr_customers_table_slrn' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.slrn | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_building-owner' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.buildingOwner | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_acc-num' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.accountNumber | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_meter-no' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.meterNo | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_dt' + (i + 1)" (click)="setFilterStorage()">
                {{ hasCimDataIntegration ? customer.substationName : customer.dtName | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_address' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.physicalAddress | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_region' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.area.regionName | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_district' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.area.name | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_tariff' + (i + 1)" (click)="setFilterStorage()">
                {{ customer.tariffName | hasValue }}
              </td>
              <td [id]="'reports_dqr_customers_table_validation-status' + (i + 1)">
                <div
                  *ngIf="
                    !customer.dqStatus &&
                    customer.assetStatus !== AssetStatus.Assigned
                  "
                  class="gray-status v-2"
                >
                  {{ "COMMON.ASSET_STATUS.PENDING" | translate }}
                </div>
                <div
                  *ngIf="customer.assetStatus === AssetStatus.Assigned"
                  class="orange-status v-2"
                >
                  {{ "COMMON.ASSET_STATUS.ASSIGNED" | translate }}
                </div>
                <div
                  *ngIf="
                    customer.dqStatus &&
                    customer.dqStatus?.toString() == 'Approved' &&
                    customer.assetStatus !== AssetStatus.Assigned
                  "
                  class="green-status v-2"
                >
                  {{ "COMMON.ASSET_STATUS.COMPLETE" | translate }}
                </div>
                <div
                  *ngIf="
                    customer.dqStatus &&
                    customer.dqStatus?.toString() == 'Rejected' &&
                    customer.assetStatus !== AssetStatus.Assigned
                  "
                  class="dark-red-status v-2"
                >
                  {{ "COMMON.ASSET_STATUS.REJECTED" | translate }}
                </div>
              </td>
              <td [id]="'reports_dqr_customers_table_tag' + (i + 1)">
                <div *ngIf="!customer.isOnBoard">
                  <div *ngIf="!customer.isNew" class="dark-green-status v-2">
                    {{ "COMMON.TAG.EXISTING" | translate }}
                  </div>
                  <div *ngIf="customer.isNew" class="green-status v-2">
                    {{ "COMMON.TAG.NEW_ENTRY" | translate }}
                  </div>
                </div>
                <div *ngIf="customer.isOnBoard">
                  <div class="olive-green-status v-2">
                    {{ "COMMON.TAG.ONBOARD" | translate }}
                  </div>
                </div>
              </td>
              <td class="td-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  data-bs-toggle="modal"
                  data-bs-target="#history"
                  (click)="viewHistory(customer.id)"
                  width="22"
                  height="22"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                  />
                </svg>
              </td>
              <td (click)="setFilterStorage()" class="more-icon">
                <img
                  src="../../assets/icons/more-icon.svg"
                  alt="More icon"
                  class="more-icon"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <app-paging
        *ngIf="count > 0"
        [pageSize]="pageSize"
        [useDirect]="true"
        [count]="count"
        [currentPage]="currentPage"
        (pageChange)="pageChange($event)"
      ></app-paging>
    </div>
  </div>
</div>
